import ArticleBibliography from './articleBibliography'

const articleBibliography = new ArticleBibliography()
articleBibliography.init()
